import { render } from "./FDICHeader.vue?vue&type=template&id=6c262b2c&scoped=true"
import script from "./FDICHeader.vue?vue&type=script&lang=js"
export * from "./FDICHeader.vue?vue&type=script&lang=js"

import "./FDICHeader.vue?vue&type=style&index=0&id=6c262b2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c262b2c"]])

export default __exports__